import React, { Component } from 'react'

class Olympics extends Component {
  shouldComponentUpdate () {
    return false
  }

  componentDidMount () {
    const s = document.createElement('script')
    s.src = 'https://sport.aktualne.cz/widget_code/04aaa6bae3e211eb8fa20cc47ab5f122.js'
    s.setAttribute('data-widget-config', JSON.stringify({ insertInto: '#top-banner-container' }))
    document.body.appendChild(s)
  }

  render () {
    return (
      <div id="top-banner-container"/>
    )
  }
}

export default Olympics
